import {borderWidths} from '../constants'

export const getBorders = (borderColor: string) => ({
  borders: {
    fine: `${borderWidths.sm} solid ${borderColor}`,
    std: `${borderWidths.md} solid ${borderColor}`,
  },
})
